export default "__VITE_ASSET__B$aCM$6R__"